import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton, CriteriumText, CriteriumIconAndText } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

const _ = require('lodash');

export const NoIndexNoFollow = ({ criterium }) => {
  const { data } = criterium;
  const { tags, hasBlockedInRobotsTxt } = data;
  const { variant } = useReviewContext();
  let text;
  if (tags.length > 0) {
    if (hasBlockedInRobotsTxt) {
      text = (
        <CriteriumIconAndText
          success={false}
          text={<Translate content='noindex_nofollow_blocked_in_robots_txt' />}
        />
      );
    } else {
      const botbyArray = _.groupBy(tags, 'bot');
      let none = false;
      let noFollow = false;
      let noIndex = false;
      _.forEach(botbyArray, function (value) {
        (value).forEach(tag => {
          if (tag.directives.none) {
            none = true;
          }
          if (tag.directives.noindex) {
            noIndex = true;
          }
          if (tag.directives.nofollow) {
            noFollow = true;
          }
        });
      });
      if (none || (noFollow && noIndex)) {
        text = (
          <CriteriumText firstLine={<Translate content='noindex_nofollow_noindex_nofollow' />} />
        );
      } else if (noFollow) {
        text = (
          <CriteriumText firstLine={<Translate content='noindex_nofollow_nofollow' />} />
        );
      } else if (noIndex) {
        text = (
          <CriteriumText firstLine={<Translate content='noindex_nofollow_noindex' />} />
        );
      } else {
        text = (
          <CriteriumText firstLine={<Translate content='noindex_nofollow_index_follow' />} />
        );
      }
    }
  } else {
    text = variant === 'nocrit' ? <CriteriumSkeleton width='70%' /> : <Translate content='noindex_nofollow_index_follow' />;
  }

  return (
    <Criterium criterium={criterium}>
      {text}
    </Criterium>
  );
};

NoIndexNoFollow.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      tags: PropTypes.array,
      hasBlockedInRobotsTxt: PropTypes.bool
    })
  })
};

export default React.memo(NoIndexNoFollow);
